import React, { memo, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { getCountdown } from '../../helper/Countdown';
import useProductPageContent from '../../hooks/useProductPageContent';
import { useAppConfig } from '../../context/AppConfigContext';
import { formatCurrency, DEFAULT_COUNTRY_CODE } from '../../constants';
import { Eye } from '@phosphor-icons/react';
import useProductRecommended from '../../hooks/useProductRecommended';
import Flag from 'react-world-flags';

const SampleNextArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-right" />
        </button>
    );
});

const SamplePrevArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-left" />
        </button>
    );
});

const ProductListRecommendation = () => {
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const { fetchProductRecommended, data, status, error, resetStatus } = useProductRecommended();
    const [dataProduct, setDataProduct] = React.useState([]);

    // const { currency } = useAppConfig();

    const formatPercentageDiscount = (discount, price) => {
        const percentage = ((price - discount) / price) * 100;
        return percentage.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    };

    useEffect(() => {
        if (status === 'idle') {
            fetchProductRecommended();
        }

        if (status === 'done') {
            //console.log(data);
            const _data = data?.length > 6 ? data.slice(0, 6) : data;
            setDataProduct(_data);
        }
        // console.log(data);
        // console.log(status);
    }, [status]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getCountdown());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    let duplicatedData = [];
    // duplicatedData = [...dataProduct, ...dataProduct];
    duplicatedData = dataProduct;

    return (
        <div className="row ">
            {duplicatedData.length > 0 &&
                duplicatedData.map((item, index) => (
                    <div key={index} className="col-6 col-sm-4 col-md-4 col-lg-2 mb-10" style={{ padding: '0 6px' }}>
                        <div style={{ minHeight: '100%' }}>
                            <div
                                // default
                                // className="product-card h-100 p-8 border border-gray-100 hover-border-main-one-600 rounded-16 position-relative transition-2"
                                className="product-card p-8 border border-gray-100 hover-border-main-one-600 rounded-16 position-relative transition-2"
                                style={{ maxWidth: 'calc(100% - 6px)', minHeight: '415px', margin: '0 auto' }}
                            >
                                <div className="w-100">
                                    {item?.discountPrice > 0 && item?.discountPrice < item?.price && (
                                        <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white">
                                            Sale {Number(item?.discount)?.toFixed(0)?.toLocaleString('en-US')}%
                                        </span>
                                    )}
                                    <Link
                                        to={`/product-details/${encodeURIComponent(item?.slug)}`}
                                        className="product-card__thumb flex-center"
                                    >
                                        <img
                                            // src={
                                            //     item.photoData && item.photoData.length > 0
                                            //         ? item.photoData[0].url
                                            //         : "/assets/images/no-image.png"
                                            // }
                                            src={item.photoData?.[0]?.url + '?width=225' || '/assets/images/no-image.png'}
                                            alt=""
                                            // className="w-auto max-w-unset"
                                        />
                                    </Link>
                                </div>

                                <div className="product-card__content p-sm-2" style={{ minWidth: '100%' }}>
                                    <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                        <Link to={`/product-details/${encodeURIComponent(item?.slug)}`} className="link text-line-2">
                                            {item.name}
                                        </Link>
                                    </h6>
                                    <Link to={`/seller-store?storeid=${item.companyId}`}>
                                        <div className="flex-align gap-4">
                                            <span
                                                className="text-main-one-600 text-md d-flex"
                                                style={{ border: '1px solid #eeeeee', minWidth: '24px' }}
                                            >
                                                {/* <i className="ph-fill ph-storefront" />
                                                 */}
                                                <Flag code={item?.flag || DEFAULT_COUNTRY_CODE} width={'24'} />
                                            </span>
                                            <span
                                                className="text-gray-500 text-xs"
                                                style={{ display: 'flex', alignItems: 'center', gap: '2px' }}
                                            >
                                                <span>By {item.businessName}</span>
                                                <img src="assets/images/icon/verified.png" width={14} height={14} />
                                            </span>
                                        </div>
                                    </Link>

                                    <div className="product-card__content mt-12">
                                        <div className="product-card__price mb-8 d-flex flex-align gap-4">
                                            <span className="text-heading text-md fw-semibold d-flex flex-grow-1">
                                                {/* {currency}{" "} */}
                                                {
                                                    //item.discountPrice !== 0 || item.discountPrice !== null || item.discountPrice !== "" ? (
                                                    Number(item.discountPrice) > 0
                                                        ? formatCurrency(item.discountPrice)
                                                        : formatCurrency(item.price)
                                                }{' '}
                                                <span className="text-gray-500 fw-normal">/Qty</span>{' '}
                                            </span>
                                            {
                                                //(item.discountPrice !== 0 || item.discountPrice !== null || item.discountPrice !== "") && (
                                                Number(item.discountPrice) > 0 && (
                                                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-flex flex-grow-1">
                                                        {/* {currency}{" "} */}
                                                        {
                                                            // item.discountPrice !== 0 || item.discountPrice !== null || item.discountPrice !== "" ? (
                                                            Number(item.discountPrice) > 0
                                                                ? formatCurrency(item.price)
                                                                : formatCurrency(item.discountPrice)
                                                        }
                                                    </span>
                                                )
                                            }
                                            {item?.viewCount && (
                                                <span className="text-gray-500 fw-normal d-flex flex-align gap-4">
                                                    <Eye size={16} /> {item?.viewCount}
                                                </span>
                                            )}
                                        </div>
                                        {/* <div className="flex-align gap-6">
                                                        <span className="text-xs fw-bold text-gray-600">4.8</span>
                                                        <span className="text-15 fw-bold text-warning-600 d-flex">
                                                            <i className="ph-fill ph-star" />
                                                        </span>
                                                        <span className="text-xs fw-bold text-gray-600">(17k)</span>
                                                    </div> */}
                                        <Link
                                            // to="/cart"
                                            to={`/product-details/${encodeURIComponent(item?.slug)}`}
                                            className="product-card__cart btn bg-white border-main-one-600 text-main-one-600 hover-bg-main-one-600 hover-text-white  rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center"
                                        >
                                            {/* Add To Cart <i className="ph ph-shopping-cart" /> */}
                                            Visit Now
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
        </div>
    );
};

export default ProductListRecommendation;
